import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const BookingPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-of-service">
      <SEO
        title="Booking & Cancellation Policy | ART Aesthetics & Skincare"
        description="Read ART Aesthetics & Skincare booking, cancellation, late arrival, and no-show policy before your appointment."
        path="/booking-policy"
      />
      <button onClick={() => navigate('/')} className="back-button">← Back to Home</button>
      <div className="privacy-container">
        <h1>Booking & Cancellation Policy</h1>

        <section>
          <p>
            At ART Aesthetics & Skincare, appointment times are reserved exclusively for you.
            To ensure fairness and protect clinic time, the following policy applies.
          </p>
        </section>

        <section>
          <h2>Booking Fee</h2>
          <ul>
            <li>A non-refundable booking fee of 30% is required to secure your appointment.</li>
            <li>This fee is deducted from the total cost of your treatment on the day.</li>
            <li>Appointments are not confirmed until the booking fee has been received.</li>
          </ul>
        </section>

        <section>
          <h2>Cancellations & Rescheduling</h2>
          <p>A minimum of 48 hours' notice is required to cancel or reschedule your appointment.</p>
          <ul>
            <li>With 48 hours' notice, your booking fee may be transferred to a new appointment date once.</li>
            <li>The transferred appointment cannot be moved again.</li>
            <li>With less than 48 hours' notice, the booking fee will be retained.</li>
          </ul>
          <p>This policy applies to all treatments and consultations.</p>
        </section>

        <section>
          <h2>Late Arrivals</h2>
          <p>
            If you arrive late, your appointment time may need to be shortened to avoid impacting
            other clients.
          </p>
          <p>
            In some cases, your appointment may need to be cancelled due to not having enough
            time to complete the treatment.
          </p>
          <p>The full treatment fee will still apply.</p>
        </section>

        <section>
          <h2>No-Shows</h2>
          <p>Failure to attend your appointment without notice will result in the loss of your booking fee.</p>
          <p>
            Repeated missed appointments may require full payment at the time of booking for
            future visits.
          </p>
        </section>
      </div>
    </div>
  );
};

export default BookingPolicy;